module.exports = __webpack_public_path__ + "img/05源泰代表.6fa89094.png";